<template>
    <app-admin-layout>
        <Head>
            <title>Kunde</title>
        </Head>
        <form @submit.prevent="submit">
            <div class="client-user">
                <div class="client-user--header" v-sticky>
                    <description-group>
                        <description-element :caption="form?.client_no" title="Kunden-Nr"/>
                        <description-element :caption="form?.company" title="Firma"/>
                        <description-element :caption="form?.name" title="Name"/>
                        <description-element :caption="form?.email" title="Email"/>
                        <description-element :caption="this.clientUser?.status ? 'aktiv' : 'deaktiviert'"
                                             title="Status"/>
                    </description-group>
                </div>
                <div class="client-user--content">
                    <div class="container">
                        <div class="row">
                            <div class="col col-6">
                                <card>
                                    <card-header>
                                        <card-overline>Stammdaten</card-overline>
                                    </card-header>
                                    <card-content>
                                        <form-input id="client_no" label="Kunden-Nr" v-model="form.client_no"
                                                    :error="form.errors.client_no" disabled="true"/>
                                        <form-input id="company" label="Firma" v-model="form.company"
                                                    :error="form.errors.company"/>
                                        <form-input id="name" label="Name" v-model="form.name"
                                                    :error="form.errors.name"/>
                                        <form-group>
                                            <form-input id="street" label="Straße" v-model="form.street"
                                                        :error="form.errors.street" class="three-four"/>
                                            <form-input id="street_no" label="Nr" v-model="form.street_no"
                                                        :error="form.errors.street_no" class="one-four"/>
                                        </form-group>
                                        <form-group>
                                            <form-input id="zip" label="Plz" v-model="form.zip" :error="form.errors.zip"
                                                        class="one-four"/>
                                            <form-input id="city" label="Ort" v-model="form.city"
                                                        :error="form.errors.city"
                                                        class="three-four"/>
                                        </form-group>
                                        <form-select id="client_country_id" label="Land" :options="clientCountries"
                                                     v-model="form.client_country_id"
                                                     :error="form.errors.client_country_id"/>
                                        <form-input id="vat_id" label="USt-Id." v-model="form.vat_id"
                                                    :error="form.errors.vat_id"/>
                                        <form-input id="website" label="Webseite" v-model="form.website"
                                                    :error="form.errors.website"/>
                                        <form-select id="language" label="Sprache" v-model="form.language"
                                                     :options="$page.props.languages"
                                                     :error="form.errors.language"/>
                                        <form-input id="phone" label="Festnetz" v-model="form.phone"
                                                    :error="form.errors.phone"/>
                                        <form-input id="mobile" label="Mobil" v-model="form.mobile"
                                                    :error="form.errors.mobile"/>
                                    </card-content>
                                </card>
                                <card>
                                    <card-header>
                                        <card-overline>Buchhaltung</card-overline>
                                    </card-header>
                                    <card-content>
                                        <form-input id="invoice_mail" label="Rechnungs Email"
                                                    v-model="form.invoice_mail"
                                                    :error="form.errors.invoice_mail"/>

                                        <form-checkbox id="bill_per_mail" label="Rechnungsversand"
                                                       option="Rechnung per Post"
                                                       v-model:checked="form.bill_per_mail"/>
                                    </card-content>
                                </card>
                            </div>
                            <div class="col col-6">
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Kundenstatus</card-overline>
                                            </card-header>
                                            <card-content>
                                                <table class="table table--card table--th-middle">
                                                    <tr>
                                                        <th style="width: 160px;">Status:</th>
                                                        <td>
                                                            <strong v-if="clientUser?.status"
                                                                    class="text-success">aktiv</strong>
                                                            <strong v-if="!clientUser?.status"
                                                                    class="text-error">deaktiviert</strong>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Bestätigt:</th>
                                                        <td><strong v-if="clientUser?.confirmed"
                                                                    class="text-success">ja</strong>
                                                            <strong v-if="!clientUser?.confirmed"
                                                                    class="text-error">nein</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <th>Letzter Login:</th>
                                                        <td>{{
                                                                clientUser?.last_login ? this.$dateTime(clientUser?.last_login) : '-'
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Login-IP:</th>
                                                        <td>{{
                                                                clientUser?.last_login_ip ? clientUser?.last_login_ip : '-'
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Pflichtinfo akzeptiert:</th>
                                                        <td>{{
                                                                clientUser?.mandatory_info ? this.$dateTime(clientUser?.mandatory_info) : '-'
                                                            }}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Account</card-overline>
                                            </card-header>
                                            <card-content>
                                                <div class="row">
                                                    <div class="col">
                                                        <form-input id="email" label="Email" v-model="form.email"
                                                                    :error="form.errors.email"/>
                                                        <form-checkbox id="is_checked" label="Verifizierung"
                                                                       option="Kunde ist geprüft"
                                                                       v-model:checked="form.is_checked"/>

                                                        <form-select id="bill_unlocked" label="Kundenkonto"
                                                                     v-model="form.bill_unlocked"
                                                                     :options="billUnlockedOptions"/>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col col-4" v-if="clientUser">
                                                        <form-button type="button" color="secondary" class="btn--block"
                                                                     icon="button-arrow-right-circle"
                                                                     @click="inviteClient" :disabled="inviteClientProcessing" :class="{'btn--processing': inviteClientProcessing}">
                                                            Bestätigungsmail erneut schicken
                                                        </form-button>
                                                    </div>
                                                    <div class="col col-4" v-if="clientUser">
                                                        <form-button type="button" color="error" class="btn--block"
                                                                     v-if="clientUser?.status"
                                                                     icon="button-arrow-right-circle"
                                                                     @click="disableClient">
                                                            Account deaktivieren
                                                        </form-button>
                                                        <form-button type="button" color="secondary" class="btn--block"
                                                                     v-if="!clientUser?.status"
                                                                     icon="button-arrow-right-circle"
                                                                     @click="disableClient" :disabled="disableClientProcessing" :class="{'btn--processing': disableClientProcessing}">
                                                            Account aktivieren
                                                        </form-button>
                                                    </div>
                                                </div>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Kommentar zum Kunden</card-overline>
                                            </card-header>
                                            <card-content>
                                                <form-text id="comment" label="Kommentar" v-model="form.comment"
                                                           :error="form.errors.comment"></form-text>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="client-user--footer" v-sticky>
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <form-actions>
                                    <form-button type="submit" color="secondary"
                                                 icon="button-arrow-right-circle"
                                                 class="btn--block" :disabled="form.processing"
                                                 :class="{'btn--processing': form.processing}">
                                        Speichern
                                    </form-button>
                                </form-actions>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import {useForm} from '@inertiajs/vue3';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import FormActions from '@partfactory/Shared/Form/FormActions';
import FormText from '@partfactory/Shared/Form/FormText';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';

export default {
    name: 'ClientUser',
    components: {
        DescriptionElement,
        FormText,
        FormActions,
        DescriptionGroup,
        FormSelect,
        FormButton,
        FormCheckbox,
        FormGroup,
        FormInput,
        CardContent,
        CardOverline,
        CardHeader,
        Card,
        AppAdminLayout
    },
    props: {
        'clientUser': Object,
        'clientCountries': Object,
    },
    data() {
        // _token: usePage().props.value.csrf_token
        const form = useForm({
            'client_no': this?.clientUser?.client_no,
            'email': this?.clientUser?.email,
            'company': this?.clientUser?.company,
            'name': this?.clientUser?.name,
            'department': this?.clientUser?.department,
            'street': this?.clientUser?.street,
            'street_no': this?.clientUser?.street_no,
            'zip': this?.clientUser?.zip,
            'city': this?.clientUser?.city,
            'client_country_id': this?.clientUser?.client_country_id,
            'phone': this?.clientUser?.phone,
            'mobile': this?.clientUser?.mobile,
            'website': this?.clientUser?.website,
            'vat_id': this?.clientUser?.vat_id,
            'language': this?.clientUser?.language,
            'comment': this?.clientUser?.comment,
            'bill_per_mail': !!this?.clientUser?.bill_per_mail,
            'invoice_mail': this?.clientUser?.invoice_mail,
            'is_checked': !!this?.clientUser?.is_checked,
            'bill_unlocked': this?.clientUser?.bill_unlocked,
        });

        const inviteClientProcessing = false, disableClientProcessing = false;

        return {form, inviteClientProcessing, disableClientProcessing};
    },
    computed: {
        billUnlockedOptions() {
            return [
                {'value': 2, 'text': 'Premium Kunde'},
            ];
        },
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    send_report: this.form.send_report ? '1' : '0',
                    _token: this.$page.props.csrf_token,
                }))
                .patch(this.$route('admin.client-user.update', {'clientUser': this.clientUser.id}), {
                    onError: () => {
                        let errorElement = document.querySelector('.form-element--error')?.getBoundingClientRect();
                        if (errorElement) {
                            const container = document.querySelector('.sidebar--content');
                            container.scrollTo(
                                (errorElement.left + container.scrollLeft),
                                (errorElement.top + container.scrollTop) - 76
                            );
                        }
                    }
                });
        },
        inviteClient() {
            this.$inertia.post(this.$route('admin.client-user.invite', {'clientUser': this.clientUser.id}), {}, {
                onStart: () => {
                    this.inviteClientProcessing = true;
                }, onFinish: () => {
                    this.inviteClientProcessing = false;
                },
            });
        },
        disableClient() {
            this.$inertia.patch(this.$route('admin.client-user.disable', {'clientUser': this.clientUser.id}), {}, {
                onStart: () => {
                    this.disableClientProcessing = true;
                }, onFinish: () => {
                    this.disableClientProcessing = false;
                },
            });
        },
    },

};
</script>
